import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import Permission from 'spark-util/Permission';
import { paths } from './manageRolesRoutes';

const ManageRoles = loadableModule(() => import('./index.js'));

const ManageRolesRoute = () => (
	<Permission requires="sm.manageRoles">
		<Route path={paths.root} component={ManageRoles} />
	</Permission>
);

export default ManageRolesRoute;